import React from "react";
import { Box } from "@mantine/core";
import NestedScreen from "../../drawer/NestedScreen";
import { MobileFullScreen } from "../sheets/MobileFullScreen";
import WalkInForm, {
  type WalkInFormProps,
  type WalkInFormTarget,
} from "../../waitlist/WalkInForm";

export interface MobileWalkInScreenProps {
  /** null = closed. */
  target: WalkInFormTarget | null;
  services: WalkInFormProps["services"];
  onSave: WalkInFormProps["onSave"];
  onClose: () => void;
  availability?: WalkInFormProps["availability"];
}

/**
 * New / Edit walk-in on a phone: the desktop drawer's form (WalkInForm in the
 * shared NestedScreen) as a full-screen push (MobileFullScreen, 460ms
 * slide-up). Back, Cancel and Escape close it.
 */
export const MobileWalkInScreen: React.FC<MobileWalkInScreenProps> = ({
  target,
  services,
  onSave,
  onClose,
  availability,
}) => (
  <MobileFullScreen
    opened={!!target}
    onClose={onClose}
    title={target?.mode === "edit" ? "Edit walk-in" : "New walk-in"}
  >
    {target && (
      <Box
        h="100%"
        data-testid="mobile-walk-in-screen"
        onKeyDown={(e) => {
          if (e.key !== "Escape" || e.defaultPrevented) return;
          // An open dropdown (client / service) closes first.
          if (
            document.querySelector(
              ".mantine-Combobox-dropdown, .mantine-Select-dropdown",
            )
          )
            return;
          e.preventDefault();
          e.stopPropagation();
          onClose();
        }}
      >
        <WalkInForm
          key={target.mode === "edit" ? target.entry.uuid : "new"}
          target={target}
          services={services}
          availability={availability}
          variant="sheet"
          onCancel={onClose}
          onSave={onSave}
          frame={({ title, subtitle, body, footer }) => (
            <NestedScreen
              title={title}
              subtitle={subtitle}
              onBack={onClose}
              footer={footer}
            >
              {body}
            </NestedScreen>
          )}
        />
      </Box>
    )}
  </MobileFullScreen>
);
